import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import { handleGetRequest } from "../../services/GetTemplate";
import { toast } from "react-toastify";

function GateLogPicture({ gateLogId }) {
  const [showModal, setShowModal] = useState(false);
  const [imageData, setImageData] = useState(null);

  const onCloseModal = () => {
    setShowModal(false);
  };

  const onViewImage = async () => {
    try {
      // Fetch the image data when the "Show picture" button is clicked
      const response = await handleGetRequest("gateLog/id/" + gateLogId);
      if (response.data) {
        // Assuming that response.data contains the Base64 encoded image data
        setImageData(response.data);
        setShowModal(true);
      }
    } catch (error) {
      toast.warn("No Image found");
      console.error("Error fetching image:", error);
    }
  };

  return (
    <>
      <Button
        icon="pi pi-eye"
        className="p-button-rounded p-button-warning p-mr-2"
        tooltip="Show picture"
        onClick={onViewImage}
        tooltipOptions={{ position: "top" }}
      />
      <Dialog
        visible={showModal}
        style={{ width: "70vw" }}
        onHide={onCloseModal}
      >
        {imageData && (
          <img
            src={`data:image/png;base64,${imageData}`} // Change 'image/png' to the appropriate MIME type
            alt="Gate Log"
            style={{ width: "100%" }}
          />
        )}
      </Dialog>
    </>
  );
}

export default GateLogPicture;
